import client from '../utils/client';

/**
 * Add service
 */
export async function addRecord(name) {
  return await client.post(`/roles/`, {
    name: name,
  });
}

/**
 * View  service
 */
export async function viewAllRecord() {
  return await client.get(`/roles/`, {});
}

/**
 * View each service
 */
export async function viewEachRecord(id) {
  return await client.get(`/roles/${id}`, {});
}

/**
 * Update service
 */
export async function updateRecord(name, id) {
  return await client.put(`/roles/${id}`, {
    name: name,
  });
}

/**
 * Delete service
 */
export async function deleteRecord(id) {
  return await client.remove(`/roles/${id}`, {});
}
